import { BuyerRequests } from './requestsData/BuyerRequests';
import { SupplierRequests } from './requestsData/SupplierRequests';
import { InternalOpsRequests } from './requestsData/InternalOpsRequests';

export function getRequestsDataForRole(platformRole) {
    if (platformRole === 'buyer' || platformRole === 'broker') {
        return BuyerRequests;
    }
    if (platformRole === 'supplier') {
        return SupplierRequests;
    }
    return InternalOpsRequests;
}

export function getFacilityUpdateUrl(type) {
    if (type === 'master_spot') {
        return 'updateMasterSpotFacilityDetails';
    }
    if (type === 'sf_working_capital') {
        return 'updateWorkingCapitalFacilityDetails';
    }
    if (type === 'spot_credit') {
        return 'updateSpotFacilityDetails';
    }
    return null;
}

export function getCreditDebitFlag(facilityUpdateType) {
    if (facilityUpdateType === 'Withdraw') {
        return 'debit';
    }
    if (facilityUpdateType === 'Add') {
        return 'credit';
    }
    return null;
}

export function getUpdatedFacilityDisplayValue(facilityAmt, facilityAmount, facilityUpdateType, PropertyFormat, amountFormat) {
    if (isNaN(parseFloat(facilityAmt)) || isNaN(parseFloat(facilityAmount))) {
        return `${PropertyFormat(parseFloat(facilityAmt), amountFormat)}`;
    }
    if (facilityUpdateType === 'Add') {
        return `${PropertyFormat(parseFloat(facilityAmt) + parseFloat(facilityAmount), amountFormat)}`;
    }
    return `${PropertyFormat(parseFloat(facilityAmt) - parseFloat(facilityAmount), amountFormat)}`;
}

export function getSubmitUpdateType(props, selectedCategory) {
    if (props.requestType === 'profile_update') {
        return props.updateType;
    }
    if (props.type === 'credit_limit_extension' || props.type === 'offer_limit_extension') {
        return null;
    }
    return selectedCategory;
}

export function mapCustomDocuments(docs) {
    return docs?.map((_a) => ({
        created_at: _a.created_at,
        document_name: _a.document_name || _a.comment,
        document_ulid: _a.document_ulid,
        file_name: _a.file_name,
        ulid: _a.ulid,
    }));
}

export function mapUpdatedCustomDocuments(docs) {
    return docs?.map((_a) => ({
        ulid: _a.ulid,
        document_ulid: _a.document_ulid,
        document_name: _a.document_name,
        created_at: _a.created_at,
        file_name: _a.file_name,
    }));
}

export function stripFeeDetailBuyers(feeDetails) {
    return feeDetails.map((feeDetail) => {
        const updatedFeeDetail = { ...feeDetail };
        delete updatedFeeDetail.buyers;
        delete updatedFeeDetail.buyer_credit_limit;
        return updatedFeeDetail;
    });
}

export function appendPayloadFiles(formData, payloadRecords) {
    for (const record of payloadRecords) {
        for (const file of record.files) {
            formData.append(record.section, file);
        }
    }
}

export function applyMasterSpotFacilityAmount(value, facilityUpdateType, getFacilityBalance, setters) {
    const sfWorkingCapitalBalance = getFacilityBalance('sf_working_capital');
    const sfMasterSpotBalance = getFacilityBalance('master_spot');

    if (facilityUpdateType === 'Add' && value > sfWorkingCapitalBalance) {
        setters.setFacilityAmountError(true);
        setters.setFacilityAmountErrorMsg('Input value should not be greater than working capital balance');
    } else if (facilityUpdateType === 'Withdraw' && value > sfMasterSpotBalance) {
        setters.setFacilityAmountError(true);
        setters.setFacilityAmountErrorMsg('Input value should not be greater than master spot balance');
    } else {
        setters.setFacilityAmount(value);
    }
}

export function applySpotCreditFacilityAmount(
    value,
    facilityUpdateType,
    getFacilityBalance,
    availableBuyerCreditBalance,
    setters
) {
    const sfMasterSpotBalance = getFacilityBalance('master_spot');

    if (facilityUpdateType === 'Add' && value > sfMasterSpotBalance) {
        setters.setFacilityAmountError(true);
        setters.setFacilityAmountErrorMsg('Input value should not be greater than working capital balance');
    } else if (facilityUpdateType === 'Withdraw' && value > availableBuyerCreditBalance) {
        setters.setFacilityAmountError(true);
        setters.setFacilityAmountErrorMsg('Input value should not be greater than buyer spot amount');
    } else {
        setters.setFacilityAmount(value);
    }
}

export function applyWorkingCapitalFacilityAmount(value, facilityUpdateType, getFacilityBalance, setters) {
    const sfWorkingCapitalBalance = getFacilityBalance('sf_working_capital');

    if (facilityUpdateType === 'Withdraw' && value > sfWorkingCapitalBalance) {
        setters.setFacilityAmountError(true);
        setters.setFacilityAmountErrorMsg('Input value should not be greater than working capital balance');
    } else {
        setters.setFacilityAmount(value);
    }
}

export function applyFacilityAmountChange({
    value,
    facilityUpdateType,
    facilityType,
    availableBuyerCreditBalance,
    getFacilityBalance,
    setFacilityAmount,
    setFacilityAmountError,
    setFacilityAmountErrorMsg,
}) {
    const setters = { setFacilityAmount, setFacilityAmountError, setFacilityAmountErrorMsg };
    setFacilityAmountError(false);
    if (!isNaN(value) && /^\d{0,13}(\.\d{0,2})?$/.test(value)) {
        if (facilityUpdateType) {
            if (facilityType === 'master_spot') {
                applyMasterSpotFacilityAmount(value, facilityUpdateType, getFacilityBalance, setters);
            }
            if (facilityType === 'spot_credit') {
                applySpotCreditFacilityAmount(
                    value,
                    facilityUpdateType,
                    getFacilityBalance,
                    availableBuyerCreditBalance,
                    setters
                );
            }
            if (facilityType === 'sf_working_capital') {
                applyWorkingCapitalFacilityAmount(value, facilityUpdateType, getFacilityBalance, setters);
            }
        } else {
            setFacilityAmount(0);
            setFacilityAmountError(true);
            setFacilityAmountErrorMsg('Please select Add/Withdraw first');
        }
    } else {
        setFacilityAmountError(true);
        setFacilityAmountErrorMsg('Invalid input value');
    }
}

export function applyKycCustomDocuments(payloadKyc) {
    if (payloadKyc?.kyc?.custom_documents) {
        payloadKyc.kyc.custom_documents = mapCustomDocuments(payloadKyc.kyc.custom_documents);
    }
    if (payloadKyc?.kyc?.updated_custom_documents) {
        payloadKyc.kyc.updated_custom_documents = mapUpdatedCustomDocuments(payloadKyc.kyc.updated_custom_documents);
    }
    return payloadKyc;
}

export function applySupplierFeeDetails(updatePayload) {
    if (updatePayload?.termSheet?.fee_details) {
        updatePayload.termSheet.fee_details = stripFeeDetailBuyers(updatePayload.termSheet.fee_details);
    }
    return updatePayload;
}

export function runUpdateFacilityValidation({
    facilityUpdateType,
    facilityAmount,
    facilityAmt,
    setFacilityUpdateTypeError,
    setFacilityUpdateTypeErrorMsg,
    setFacilityAmountError,
    setFacilityAmountErrorMsg,
    fetchFacilityUpdate,
    facilityType,
}) {
    if (facilityUpdateType === '' || !facilityUpdateType) {
        setFacilityUpdateTypeError(true);
        setFacilityUpdateTypeErrorMsg('Please select add/withdraw');
    } else if (!facilityAmount || facilityAmount === '' || facilityAmount === null || facilityAmount === '0') {
        setFacilityAmountError(true);
        setFacilityAmountErrorMsg('Please enter valid value');
    } else if (facilityUpdateType === 'Withdraw' && parseFloat(facilityAmount) > parseFloat(facilityAmt)) {
        setFacilityAmountError(true);
        setFacilityAmountErrorMsg('Withdrawl amount cannot be greater than current value');
    } else {
        setFacilityUpdateTypeError(false);
        setFacilityAmountError(false);
        fetchFacilityUpdate(facilityType);
    }
}

export function applyCreditEngineRequestIds(newPayload, updateRequestData) {
    if (
        updateRequestData &&
        updateRequestData.request_id &&
        updateRequestData.request_ulid &&
        updateRequestData.request_status
    ) {
        newPayload.id = updateRequestData.request_id;
        newPayload.ulid = updateRequestData.request_ulid;
        newPayload.status = updateRequestData.request_status;
    }
    return newPayload;
}

export function isAmountRequiredRequest(selectedRequest) {
    return (
        selectedRequest === 'credit_limit_extension' ||
        selectedRequest === 'offer_limit_extension' ||
        selectedRequest === 'Supplier Spot Credit Extension' ||
        selectedRequest === 'spot_credit'
    );
}

export function isCreditExtensionRequest(props) {
    return (
        props.requestType === 'supplier_facility_credit_extension' ||
        props.type === 'credit_limit_extension' ||
        props.type === 'offer_limit_extension'
    );
}

export function isProfileTypeRequest(props) {
    return (
        props?.profileType === 'buyer' ||
        props?.profileType === 'supplier' ||
        props?.profileType === 'investor' ||
        props?.isUpdateByUserOnly
    );
}

export function applyInitialRequestSelections(props, setters) {
    if (props.type) {
        setters.setSelectedRequest(props.type);
    } else {
        setters.setSelectedRequest('Select');
    }
    if (props?.requestType === 'supplier_facility_credit_extension') {
        setters.setAmount(props.amount);
        setters.setSelectedRequest('Supplier Spot Credit Extension');
    }
    if (props.requestType === 'set_buyer_credit') {
        setters.setAmount(props.payload.riskDecision.allocatedCreditLimit);
        setters.setSelectedRequest('set_buyer_credit');
    }
    if (props?.profileType === 'buyer') {
        setters.setSelectedRequest('add_buyer');
    }
    if (props?.profileType === 'supplier') {
        setters.setSelectedRequest('add_supplier');
    }
    if (props?.profileType === 'investor') {
        setters.setSelectedRequest('add_investor');
    }
    return props.requestType === 'update_facility';
}
